
export class BlockDto {

    blockId;
    code;
    name;
    active;
    creationPerson;
    creationDate;
    modificationPerson;
    modificationDate;
    questionList;
 }